import axios from 'axios';

const baseURL = process.env.REACT_APP_API_BASE_URL;

const AxiosInstance = () =>
  axios.create({
    baseURL,
    timeout: 60000,
    headers: {
      'Content-Type': 'application/json',
    },
  });

const axiosInstance = AxiosInstance();

export default axiosInstance;
